var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCrm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.022,
    y1: 0.282,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4af3e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14e2f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41249",
    "data-name": "Group 41249",
    transform: "translate(-1822 -203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6704",
    "data-name": "Rectangle 6704",
    width: 64,
    height: 64,
    rx: 32,
    transform: "translate(1822 203)",
    opacity: 0.07,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6703",
    "data-name": "Rectangle 6703",
    width: 52,
    height: 52,
    rx: 26,
    transform: "translate(1828 209)",
    opacity: 0.11,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6702",
    "data-name": "Rectangle 6702",
    width: 44,
    height: 44,
    rx: 22,
    transform: "translate(1832 213)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(1840 220.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81378",
    "data-name": "Path 81378",
    d: "M21,28H19a.5.5,0,0,1,0-1h2a5.549,5.549,0,0,0,5.5-5.5v-1a.5.5,0,0,1,1,0v1A6.487,6.487,0,0,1,21,28Z",
    fill: "#f9fdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81379",
    "data-name": "Path 81379",
    d: "M19.5,27.5a.945.945,0,0,1-1,1h-1a1,1,0,0,1,0-2h1A.945.945,0,0,1,19.5,27.5Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81380",
    "data-name": "Path 81380",
    d: "M26,16a.472.472,0,0,1-.5-.5v-3a.5.5,0,0,1,1,0v3A.472.472,0,0,1,26,16ZM5,16a.472.472,0,0,1-.5-.5v-3A.472.472,0,0,1,5,12a.472.472,0,0,1,.5.5v3A.472.472,0,0,1,5,16Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81381",
    "data-name": "Path 81381",
    d: "M25,15.5h2a.945.945,0,0,1,1,1v4a.945.945,0,0,1-1,1H25Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81382",
    "data-name": "Path 81382",
    d: "M25.9,13a.972.972,0,0,0,1-1.1,11.448,11.448,0,0,0-22.8,0,.972.972,0,0,0,1,1.1,1.063,1.063,0,0,0,1-.9,9.547,9.547,0,0,1,19,0A.765.765,0,0,0,25.9,13Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81383",
    "data-name": "Path 81383",
    d: "M6.1,11.9A11.523,11.523,0,0,1,16.5,1.5h-1A11.43,11.43,0,0,0,4.1,11.9a.972.972,0,0,0,1,1.1,1.063,1.063,0,0,0,1-.9c-.1,0,0-.1,0-.2h0ZM17.5,3.5a3.4,3.4,0,0,0-1,.1A9.676,9.676,0,0,1,25,12.2a.987.987,0,0,0,1,.9,1,1,0,0,0,1-1A9.619,9.619,0,0,0,17.5,3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81386",
    "data-name": "Path 81386",
    d: "M7,22.5a.945.945,0,0,1-1-1v-6a.945.945,0,0,1,1-1,.945.945,0,0,1,1,1v6A.945.945,0,0,1,7,22.5Zm17-8a.945.945,0,0,1,1,1v6a1,1,0,0,1-2,0v-6A.945.945,0,0,1,24,14.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81387",
    "data-name": "Path 81387",
    d: "M7,20.5a.945.945,0,0,1-1-1v2a.945.945,0,0,0,1,1,.945.945,0,0,0,1-1v-2A.945.945,0,0,1,7,20.5Zm17,0a.945.945,0,0,1-1-1v2a1,1,0,0,0,2,0v-2A.945.945,0,0,1,24,20.5Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81388",
    "data-name": "Path 81388",
    d: "M6,21.5H4a.945.945,0,0,1-1-1v-4a.945.945,0,0,1,1-1H6Z",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81389",
    "data-name": "Path 81389",
    d: "M4.5,15.5V19a.945.945,0,0,1-1,1H3v.5a.945.945,0,0,0,1,1H6v-6Zm22,0V19a.945.945,0,0,0,1,1H28v.5a.945.945,0,0,1-1,1H25v-6Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCrm);
export default __webpack_public_path__ + "static/media/help-crm.ce677eaa0fe08eba144f5846ac3191eb.svg";
export { ForwardRef as ReactComponent };